<template>
  <div class="gallery user_images_gallery">
    <div class="matrix_uploadContainer">
      <div class="matrix_upload">
        <div class="upload_btn drop-area">
          <!--       <file-upload
        ref="upload"
        v-model="files"
        name="files[]"
        :post-action="uploadUserPhotoUrl"
        :data="{ customer: customer }"
        @input-file="inputFile"
      >
        <button type="button" class="btn btn-primary">
          {{ $t("Upload your own files") }}
        </button>
      </file-upload> -->
          <vue-dropzone
            :id="refId"
            :ref="refId"
            :options="dropzoneOptions"
            @vdropzone-complete="afterComplete"
            @vdropzone-sending="sendFile"
            @vdropzone-file-added="fileAdded"
            @vdropzone-drop="drop"
            @vdropzone-error="error"
            @vdropzone-mounted="mounted"
            @vdropzone-upload-progress="progress"
          >
          </vue-dropzone>
        </div>
      </div>
    </div>
    <appImageEditorGallery :items="items" :hideDelete="false" />
  </div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useCustomerStore } from "@/stores/modules/customer";
import { useUrlsStore } from "@/stores/modules/urls";
import { mapState, mapActions } from "pinia";
import { useUploadsStore } from "@/stores/modules/uploads";
import VueUploadComponent from "vue-upload-component";
import * as R from "ramda";
import ImageEditorGallery from "../imageEditorGalleries/ImageEditorGallery";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import axios from "../../axios-auth";
import vue2Dropzone from "vue2-dropzone-vue3";
import { i18n } from "../../i18n.js";

export default {
  components: {
    "file-upload": VueUploadComponent,
    appImageEditorGallery: ImageEditorGallery,
    vueDropzone: vue2Dropzone
  },
  computed: {
    ...mapState(useImageEditorStore, { POIEVariables: "getPOIEVariables" }),
    ...mapState(useUrlsStore, { uploadUserPhotoUrl: "getuploadUserPhotoUrl" }),
    ...mapState(useCustomerStore, {
      customer: "getCustomer",
      items: "getCustomerImageGalleryItems"
    }),

    ...mapState(useUploadsStore, [
      "getUploadForProductPart",
      "getFileParameters",
      "getUploadItemId"
    ]),
    refId: function () {
      return this.getUploadItemId("lfp");
    }
  },
  data: function () {
    const urlsStore = useUrlsStore();
    const webproductStore = useWebproductStore();
    const imageStore = useImageEditorStore();
    return {
      dropzoneOptions: {
        url: urlsStore.getuploadUserPhotoUrl,
        maxFilesize: webproductStore.getMaxUploadFileSize,
        dictDefaultMessage: i18n.t("Upload your Own"),
        uploadMultiple: false,
        acceptedFiles: this.getAcceptedFiles().join(","),
        paramName: "files[]",
        timeout: 0,
        previewTemplate:
          '<div id="template-preview"><div class="dz-preview dz-file-preview well" id="dz-preview-template"><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div></div></div>'
      }
    };
  },
  methods: {
    ...mapActions(usePersonalizeStore, ["setPersonalizeLoading"]),
    ...mapActions(useCustomerStore, [
      "loadCustomerGallery",
      "addCustomerImage",
      "emptyCustomerGallery"
    ]),
    getAcceptedFiles: function () {
      return [".jpg", ".jpeg", ".png", ".tif", ".tiff"];
    },
    afterComplete(file) {
      const webproductStore = useWebproductStore();
      this.setPersonalizeLoading(false);

      if (
        Math.ceil(file.size / 1024) >
        webproductStore.getMaxUploadFileSize * 1024
      ) {
        this.getSweetAlert({
          text: i18n.t(
            "File size is too large! Maximum allowed size is {max} MB.",
            {
              max: webproductStore.getMaxUploadFileSize
            }
          ),
          icon: "error"
        });
        return;
      } else if (!file.accepted) {
        this.getSweetAlert({
          text: i18n.t("File is not in accepted format!"),
          icon: "warning"
        });
        return;
      }

      if (file.status == "success") {
        console.log(file);
        if (file.xhr.response) {
          var response = JSON.parse(file.xhr.response);
          if (response.success) {
            data = response.data;
            console.log(data);
            R.forEach(item => {
              this.addCustomerImage(item);
            }, data);
          }
        }
      }
    },
    afterUploadFile: function (file_info, uploadedFile, file_url, mounted) {
      debugger;
    },
    sendFile: function (file, xhr, formData) {
      this.prepareDropzoneInput();
      const customerStore = useCustomerStore();
      formData.append("customer", customerStore.getCustomer);
    },
    drop: function (event) {
      if (event.dataTransfer && event.dataTransfer.files) {
        if (event.dataTransfer.files.length != 1) {
          this.$refs[this.refId].dropzone.multipleFilesError = true;
          this.getSweetAlert({
            text: i18n.t("Please upload just one file!"),
            icon: "warning"
          });

          return;
        }
      }

      //this.uploadLoading(true);
    },

    error: function (file, message, xhr) {
      this.uploadLoading(false);

      this.setPersonalizeLoading(false);

      if (message && message.message) {
        this.getSweetAlert({
          text: message.message,
          icon: "error"
        });
      } else if (typeof message == "string") {
        this.getSweetAlert({
          text: message,
          icon: "error"
        });
      }
      this.$refs[this.refId].removeAllFiles();
    },

    fileAdded: function (file) {
      if (this.$refs[this.refId].dropzone.multipleFilesError) {
        this.$refs[this.refId].dropzone.removeFile(file);
      }
    },
    progress: function (file, progress, bytesSent) {
      if (progress == 100) {
        this.setPersonalizeLoading(true);
      }
    },
    mounted: function () {
      this.prepareDropzoneInput();
    },
    prepareDropzoneInput() {
      var dropzone = this.$refs[this.refId].dropzone;
      dropzone.hiddenFileInput.removeAttribute("multiple");
      dropzone.multipleFilesError = false;
      dropzone.hiddenFileInput.addEventListener("click", function (event) {
        dropzone.multipleFilesError = false;
      });
    }
  },
  created() {
    this.loadCustomerGallery();
  },
  watch: {
    customer: function () {
      this.emptyCustomerGallery();
      this.loadCustomerGallery();
    }
  }
};
</script>
